import React, { useCallback, useState } from "react"
import {
  Button,
  Dropdown,
  Menu,
  Modal,
  Input,
  Typography,
  Collapse,
  List,
} from "antd"
import { PlusOutlined, UserOutlined } from "@ant-design/icons"
import { DndProvider, useDrag, useDrop } from "react-dnd"
import { HTML5Backend } from "react-dnd-html5-backend"
import AddUserModal from "./AdduserModal"
import AddClubModal from "pages/Clubs/AddClub"
import { FetchPostData, FetchPutData } from "utils/Common_api_functions"
import Loader from "components/Loader/loader"

const { Panel } = Collapse
const ItemTypes = { USER: "user" }

// Draggable user
const DraggableUser = ({ user, onUserSelect, selectedUser }) => {
  const [{ isDragging }, drag] = useDrag({
    type: ItemTypes.USER,
    item: { id: user._id },
    collect: monitor => ({
      isDragging: monitor.isDragging(),
    }),
  })

  return (
    <List.Item
      ref={drag}
      style={{ opacity: isDragging ? 0.5 : 1, cursor: "move" }}
      className={selectedUser?._id === user?._id ? "text-primary" : "text-dark"}
      onClick={() => onUserSelect(user?._id)}
    >
      <UserOutlined className="me-2" />
      {user.name}
    </List.Item>
  )
}

// Club panel
const GroupPanel = ({ club, onUserSelect, selectedUser, moveUserToGroup }) => {
  const [, drop] = useDrop({
    accept: ItemTypes.USER,
    drop: item => moveUserToGroup(item.id, club._id),
  })

  return (
    <div ref={drop} className="mb-3">
      <Collapse className="custom-dropdown">
        <Panel
          header={`${club.clubName} (${club.users.length})`}
          key={club._id}
        >
          {club.users.length > 0 ? (
            <List
              size="small"
              dataSource={club.users}
              renderItem={user => (
                <DraggableUser
                  key={user._id}
                  user={user}
                  selectedUser={selectedUser}
                  onUserSelect={onUserSelect}
                />
              )}
            />
          ) : (
            <Typography.Text type="secondary">
              No users in this club.
            </Typography.Text>
          )}
        </Panel>
      </Collapse>
    </div>
  )
}

const AthleteLibraryPanel = ({
  users,
  setUsers,
  selectedUser,
  onUserSelect,
  getClubs
}) => {
  const [isGroupModalVisible, setGroupModalVisible] = useState(false)
  const [isUserModalVisible, setUserModalVisible] = useState(false)
  const [searchText, setSearchText] = useState("")
  const [loading, setLoading] = useState(false)

  // Move user between clubs
  const moveUserToGroup = useCallback(
    async (userId, newClubId) => {
      console.log(userId, newClubId)
      const APIdata = await FetchPutData(setLoading, "user", userId, {
        club: newClubId,
      })
      if(APIdata?.data?.success){
        getClubs()
      }
    },
    [setUsers]
  )

  const handleMenuClick = ({ key }) => {
    if (key === "addGroup") setGroupModalVisible(true)
    if (key === "addUser") setUserModalVisible(true)
  }

  return (
    <DndProvider backend={HTML5Backend}>
      {loading && <Loader />}
      <div className="d-flex gap-2 mb-3">
        <Input
          type="search"
          placeholder="Search users"
          value={searchText}
          onChange={e => setSearchText(e.target.value)}
          style={{ flex: 1 }}
        />
        <Dropdown
          overlay={
            <Menu onClick={handleMenuClick}>
              <Menu.Item key="addGroup">Add Club</Menu.Item>
              <Menu.Item key="addUser">Add User</Menu.Item>
            </Menu>
          }
          placement="bottomLeft"
          trigger={["click"]}
        >
          <Button type="primary" icon={<PlusOutlined />}></Button>
        </Dropdown>
      </div>

      {/* Map over parent-provided users (clubs) */}
      {users.map(club => (
        <GroupPanel
          key={club._id}
          club={club}
          onUserSelect={onUserSelect}
          selectedUser={selectedUser}
          moveUserToGroup={moveUserToGroup}
        />
      ))}

      {/* Add Club Modal */}
      <AddClubModal
        isOpen={isGroupModalVisible}
        toggle={() => setGroupModalVisible(false)}
        onSuccess={() => {}}
      />

      {/* Add User Modal */}
      <Modal
        title="Add User"
        open={isUserModalVisible}
        onCancel={() => setUserModalVisible(false)}
        footer={null}
        centered
        width={800}
      >
        <AddUserModal setclose={setUserModalVisible} />
      </Modal>
    </DndProvider>
  )
}

export default AthleteLibraryPanel
